
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accelerated/get-started",
      function () {
        return require("private-next-pages/accelerated/get-started.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accelerated/get-started"])
      });
    }
  